import CitySEOHead from "@/components/feature/CitySEOHead";
import JensenBeachHeroSection from "./components/HeroSection";
import JensenBeachStickyNav from "./components/StickyNav";
import JensenBeachProcessingTimeSection from "./components/ProcessingTimeSection";
import JensenBeachServicesSection from "./components/ServicesSection";
import JensenBeachLocalAreaSection from "./components/LocalAreaSection";
import JensenBeachTravelTimingSection from "./components/TravelTimingSection";
import JensenBeachDestinationsSection from "./components/DestinationsSection";
import JensenBeachTestimonialsSection from "./components/TestimonialsSection";
import JensenBeachAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import JensenBeachComparisonSection from "./components/ComparisonSection";
import JensenBeachMistakesSection from "./components/MistakesSection";
import JensenBeachHowItWorksSection from "./components/HowItWorksSection";
import JensenBeachFAQSection, { faqs } from "./components/FAQSection";
import JensenBeachHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import JensenBeachFinalCTA from "./components/FinalCTA";

const jensenBeachServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  { name: "Second Passport & Damaged", description: "Second passport issuance for frequent travelers and damaged passport replacement." },
];

export default function JensenBeachPage() {
  return (
    <>
      <CitySEOHead
        city="Jensen Beach"
        state="Florida"
        stateAbbr="FL"
        route="/cities/jensen-beach"
        title="Emergency Passport Jensen Beach, FL — Expedited Same-Day Service | Fast Passport Center"
        description="Emergency and expedited passport services in Jensen Beach, FL — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Hutchinson Island, Stuart, Palm City, and Treasure Coast travelers."
        geoPlacename="Jensen Beach, Florida"
        geoPosition="27.2542;-80.2298"
        faqs={faqs}
        servicesSchema={jensenBeachServices}
      />
      <div className="font-sans">
        <JensenBeachHeroSection />
        <JensenBeachStickyNav />
        <JensenBeachProcessingTimeSection />
        <JensenBeachServicesSection />
        <JensenBeachLocalAreaSection />
        <JensenBeachTravelTimingSection />
        <JensenBeachDestinationsSection />
        <JensenBeachTestimonialsSection />
        <JensenBeachAcceptanceFacilitiesSection />
        <JensenBeachComparisonSection />
        <JensenBeachMistakesSection />
        <JensenBeachHowItWorksSection />
        <JensenBeachFAQSection />
        <JensenBeachHelpfulResourcesSection />
        <JensenBeachFinalCTA />
      </div>
    </>
  );
}